export const business_menu_data = [
    // {
    //   label: "Offers",
    //   url: "#",
    //   // children: [
    //   //   {
    //   //     label: "Business Offers",
    //   //     url: "https://telecel.com.gh/business/",
    //   //     children: [],
    //   //   },
    //   //   {
    //   //     label: "Products & Solutions",
    //   //     url: "https://telecel.com.gh/business/products-and-solutions/",
    //   //     children: [],
    //   //   },
    //   // ],
    // },
    {
      label: "Business Offers",
      url: `${process.env.Telecel_web_url}/business/`,
      children: [],
    },
    {
      label: "Products & Solutions",
      url: `${process.env.Telecel_web_url}/business/products-and-solutions/`,
      children: [],
    },
    {
      label: "Wholesale",
      url: `${process.env.Telecel_web_url}/business/wholesale/`,
      children: [],
    },
    // {
    //   label: "Mobile",
    //   url: "",
    //   children: [
    //     {
    //       label: "Tertiary Bundles",
    //       url: "",
    //       children: [
    //         {
    //           label: "Tertiary Bundles",
    //           url: "https://vodafone.com.gh/business/tertiary-bundles/",
    //           children: [],
    //         },
    //         {
    //           label: "Telecel World Plus Bundles",
    //           url: "https://vodafone.com.gh/business/roaming-bundles/",
    //           children: [],
    //         },
    //         {
    //           label: "2 Moorch Bundles",
    //           url: "https://vodafone.com.gh/business/sme/2-moorch-business/",
    //           children: [],
    //         },
    //         {
    //           label: "VAS Short Codes",
    //           url: "https://vodafone.com.gh/business/sme/vas/vas-short-codes/",
    //           children: [],
    //         },
    //         {
    //           label: "Bulk SMS",
    //           url: "https://vodafone.com.gh/business/bulk-sms/",
    //           children: [],
    //         },
    //         {
    //           label: "Toll Free Numbers",
    //           url: "https://vodafone.com.gh/business/sme/vas/toll-free-voice/",
    //           children: [],
    //         },
    //         {
    //           label: "Data Sharer",
    //           url: "https://vodafone.com.gh/business/data-sharer/",
    //           children: [],
    //         },
    //         {
    //           label: "Caller Ring Back Tunes",
    //           url: "https://vodafone.com.gh/business/corporate-ring-back-tunes/",
    //           children: [],
    //         },
    //         {
    //           label: "Red Trader",
    //           url: "https://vodafone.com.gh/business/red-trader/",
    //           children: [],
    //         },
    //       ],
    //     },
    //     {
    //       label: "Fixed Services",
    //       url: "",
    //       children: [
    //         {
    //           label: "Telecel Business Broadband",
    //           url: "https://vodafone.com.gh/business/vodafone-business-broadband/",
    //           children: [],
    //         },
    //         {
    //           label: "Enterprise Fixed Voice",
    //           url: "https://vodafone.com.gh/business/fixed-voiceline/",
    //           children: [],
    //         },
    //         {
    //           label: "Enterprise WiFi",
    //           url: "https://vodafone.com.gh/business/enterprise-wifi/",
    //           children: [],
    //         },
    //         {
    //           label: "Global IP",
    //           url: "https://vodafone.com.gh/business/global-ip/",
    //           children: [],
    //         },
    //         {
    //           label: "Wide Area Network - WAN",
    //           url: "https://vodafone.com.gh/business/wide-area-network/",
    //           children: [],
    //         },
    //         {
    //           label: "Dedicated Internet",
    //           url: "https://vodafone.com.gh/business/dedicated-internet/",
    //           children: [],
    //         },
    //       ],
    //     },
    //     {
    //       label: "IoT",
    //       url: "",
    //       children: [
    //         {
    //           label: "Speedlink",
    //           url: "https://vodafone.com.gh/business/iot/speedlink/",
    //           children: [],
    //         },
    //         {
    //           label: "V-track",
    //           url: "https://vodafone.com.gh/business/iot/vtrack/",
    //           children: [],
    //         },
    //       ],
    //     },
    //     {
    //       label: "Telecel Cash for Enterprise",
    //       url: "https://vodafone.com.gh/business/sme/vodafone-cash-for-enterprise/",
    //       children: [],
    //     },
    //   ],
    // },
    // {
    //   label: "Why Telecel",
    //   url: "https://vodafone.com.gh/business/why-vodafone/",
    //   children: [],
    // },
    // {
    //   label: "Help",
    //   url: "",
    //   children: [
    //     {
    //       label: "Go To Help",
    //       url: "https://support.vodafone.com.gh/",
    //       children: [],
    //     },
    //     {
    //       label: "Contact Us",
    //       url: "https://vodafone.com.gh/business/contact-us/",
    //       children: [],
    //     },
    //     {
    //       label: "FAQs",
    //       url: "https://vodafone.com.gh/help/business-faqs/",
    //       children: [],
    //     },
    //     {
    //       label: "Pricing update",
    //       url: "https://support.vodafone.com.gh/help/vodafone-business-pricing-update/",
    //       children: [],
    //     },
    //   ],
    // },
  ]